import { useMutation, useQueryClient } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'
import { toast } from 'react-toastify'
import { AppNotification } from 'Utils/types/appNotification'
import { createMetaField } from 'Services/JOONAdmin/joonAdminEmployersService'

export const useCreateMetaFieldQuery = () => {
  const queryClient = useQueryClient()

  return useMutation([QueryNames.CreateMetaField], createMetaField, {
    onSuccess: (response) => {
      if (response.success) {
        queryClient.invalidateQueries([QueryNames.EmployerMetaFields])
        queryClient.invalidateQueries([QueryNames.UsersForEmployer])
        queryClient.invalidateQueries([QueryNames.UsersWithMetadata])
        toast.success(AppNotification.CreateMetaFieldSuccess)
      } else {
        toast.error(response.message || AppNotification.CreateMetaFieldFailure)
      }
    },
    onError: () => {
      toast.error(AppNotification.CreateMetaFieldFailure)
    }
  })
}
